// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_aj-0";
export var optionCard = "_aj-1";